import {useState, useEffect} from "react";
import axios from "axios";

import Accordion from "./accordion";


export default function SafetyPolicy(){
    const [data, setData] = useState();

    const [files, setFiles] = useState();

    useEffect(() => {
        axios.get("https://api-als2.nutramax.com/items/safety_policies")
        .then(response => {
            setData(response.data.data);
        })

        axios.get("https://api-als2.nutramax.com/items/safety_policies_files")
        .then(response => {
            setFiles(response.data.data);
        })
    }, [])
    return (
        <>
        {data? data.map(({Name, id}) => { return (
            <Accordion key={id} id={id} name={Name} data={data} files={files}/>
        )}): null}
        
        </>
    )
}